export const breadcrumbs = {
  type: Array,
  default: () => ([]),
  validator: array => array.every(obj => ['title'].every(prop => obj.hasOwnProperty(prop)))
}

export const defaultEmptyString = {
  type: String,
  default: ''
}
